<template>
	<div class="container">
		<div class="content">
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/my/index' }">个人中心</el-breadcrumb-item>
					<el-breadcrumb-item>发票记录</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="policies-card">
				<div class="product-tab">
					<el-tabs v-model="activeType" @tab-click="handleTabClick">
						<el-tab-pane v-for="(item, index) in typeList" :key="index" :label="item.name"
							:name="item.name" />
					</el-tabs>
				</div>
				<table class="policies-table">
					<thead>
						<tr>
							<th>发票类型</th>
							<th>发票抬头</th>
							<th>开票时间</th>
							<th>申请时间</th>
							<th>操作</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in list" :key="index">
							<td>
								{{ item.type == 1 ? '普票' : '专票' }}
							</td>
							<td>{{ item.customer_name }}</td>
							<td>{{ item.kprq || '开票中' }}</td>
							<td>{{ item.created_at }}</td>
							<td>
								<div class="policy-actions">
									<button class="action-btn">查看详情</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="pagination" v-if="list.length > 0 && total > form._size">
					<el-pagination background layout="prev, pager, next, total" :total="total" :page-size="form._size"
						:current-page="form._page" @current-change="currentChange" />
				</div>
			</div>
		</div>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				form: {
					_page: 1,
					_size: 10,
					_order: 'id',
					_isreverse: 1,
					type: '',
				},
				list: [],
				total: 0,
				activeType: '全部',
				typeList: [
					{
						name: '全部',
						value: ''
					},
					{
						name: '电子普票',
						value: 1
					},
					{
						name: '纸质专票',
						value: 2
					},
				],

			}
		},
		mounted() {
			this.ActionList();
		},
		methods: {
			handleTabClick(tab) {
				this.form._page = 1;
				this.form.type = this.typeList[tab.index].value;
				this.ActionList();
			},
			currentChange(e) {
				this.form._page = e;
				this.ActionList();
			},
			ActionList() {
				this.$load();
				this.list = [];
				this.$get('app-order-invoice', this.form, true).then(res => {
					this.list = res.data;
					this.total = res.extra.pageInfo.count;
				}).catch(err => {
					this.$message.error(err);
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			// 笔记本适配
			@media (max-width: 1440px) {
				width: 80%;
			}
			
			@media (max-width: 1280px) {
				width: 90%;
			}
			
			@media (max-width: 1024px) {
				width: 95%;
				margin: 15px auto 30px;
			}

			/* 保单列表 */
			.policies-card {
				background: white;
				border-radius: 12px;
				padding: 24px;
				box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
				margin-top: 20px;

				// 笔记本适配
				@media (max-width: 1280px) {
					padding: 20px;
					margin-top: 15px;
				}
				
				@media (max-width: 1024px) {
					padding: 16px;
					border-radius: 8px;
				}

				.pagination {
					display: flex;
					justify-content: center;
					margin-top: 30px;

					// 笔记本适配
					@media (max-width: 1280px) {
						margin-top: 20px;
					}

					::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
						background-color: #2280FD;
						color: white;
					}

					::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
						color: #2280FD;
					}
					
					// 分页适配
					@media (max-width: 768px) {
						::v-deep .el-pagination {
							.el-pagination__total,
							.el-pagination__jump {
								display: none;
							}
						}
					}
				}

				.product-tab {
					// 笔记本适配
					@media (max-width: 1280px) {
						margin-bottom: 15px;
					}

					:deep(.el-tabs) {
						.el-tabs__item {
							font-size: 16px;
							color: #999999;
							
							// 笔记本适配
							@media (max-width: 1280px) {
								font-size: 15px;
								padding: 0 12px;
							}
							
							@media (max-width: 768px) {
								font-size: 14px;
								padding: 0 8px;
							}
						}

						.el-tabs__item.is-active {
							color: #2280FD;
						}

						.el-tabs__active-bar {
							background-color: #2280FD;
						}
					}
				}
			}

			.policies-table {
				width: 100%;
				border-collapse: collapse;
				
				// 笔记本适配 - 在较小屏幕上水平滚动
				@media (max-width: 1024px) {
					display: block;
					overflow-x: auto;
					white-space: nowrap;
				}
			}

			.policies-table th {
				background: #f8f9fa;
				padding: 16px;
				text-align: left;
				font-weight: 600;
				color: #333;
				border-bottom: 1px solid #e0e0e0;
				
				// 笔记本适配
				@media (max-width: 1280px) {
					padding: 12px 14px;
					font-size: 14px;
				}
				
				@media (max-width: 1024px) {
					padding: 10px 12px;
					font-size: 13px;
				}
			}

			.policies-table td {
				padding: 16px;
				border-bottom: 1px solid #f0f0f0;
				color: #666666;
				font-size: 14px;
				
				// 笔记本适配
				@media (max-width: 1280px) {
					padding: 12px 14px;
					font-size: 13px;
				}
				
				@media (max-width: 1024px) {
					padding: 10px 12px;
					font-size: 12px;
				}
			}

			.policies-table tr:hover {
				background: #f8f9fa;
			}

			.policy-name {
				font-weight: 500;
				color: #333;
			}

			.policy-desc {
				font-size: 12px;
				color: #666;
				margin-top: 4px;
			}

			.policy-actions {
				display: flex;
				gap: 8px;
				
				// 笔记本适配
				@media (max-width: 1280px) {
					gap: 6px;
				}
			}

			.action-btn {
				padding: 6px 12px;
				border: 1px solid #e0e0e0;
				border-radius: 6px;
				background: white;
				color: #666;
				font-size: 12px;
				cursor: pointer;
				transition: all 0.3s ease;
				
				// 笔记本适配
				@media (max-width: 1280px) {
					padding: 5px 10px;
					font-size: 11px;
				}
				
				@media (max-width: 768px) {
					padding: 4px 8px;
					font-size: 10px;
				}
			}

			.action-btn:hover {
				border-color: #2280FD;
				color: #2280FD;
			}

			.action-btn.primary {
				background: #2280FD;
				color: white;
				border-color: #2280FD;
			}

			.action-btn.primary:hover {
				background: #1a6fd0;
			}
			
			// 在小屏幕上隐藏部分列
			@media (max-width: 768px) {
				.policies-table {
					th:nth-child(3),
					td:nth-child(3),
					th:nth-child(4),
					td:nth-child(4) {
						display: none;
					}
				}
			}
			
			// 在更小屏幕上进一步调整
			@media (max-width: 480px) {
				.policies-table {
					th:nth-child(2),
					td:nth-child(2) {
						display: none;
					}
				}
				
				.policies-card {
					padding: 12px;
				}
			}
		}
	}
</style>